<template>
    <div ref="container" class="landing_video py-5 px-3">
        <div v-if="!isShowVideo" class="flex flex-column gap-3">
            <div
                class="landing_video__thumbnail"
                @click="onShowVideo"
            >
                <img
                    :src="thumbnailSrc"
                    alt="Video thumbnail"
                    width="1600"
                    height="900"
                    :loading="thumbnailLoading"
                    decoding="async"
                    :fetchpriority="thumbnailFetchPriority"
                />
            </div>
            <div class="landing_video__actions">
                <div v-if="isSmallScreen" class="w-full flex justify-content-center">
                    <Button
                        label="Запустить видео"
                        @click="onShowVideo"
                        icon="pi pi-play"
                    />
                </div>
            </div>
        </div>
        <div v-else class="landing_video__frame">
            <iframe
                :src="iframeSrc"
                :width="frameWidth"
                :height="frameHeight"
                frameborder="0"
                allow="clipboard-write; autoplay"
                allowfullscreen
                loading="lazy"
                ref="video"
            ></iframe>
        </div>
    </div>
</template>

<script>
import {nextTick} from "vue";
import Button from "primevue/button";
import {AppConstant} from "keysso/app.constant";
import {AspectRationHelper} from "keysso/helpers/AspectRationHelper";

export default {
    name: "CommonVideo",
    props: {
        videoEmbedUrl: {
            type: String,
            required: true,
        },
        videoThumbnailSmall: {
            type: String,
            required: true,
        },
        videoThumbnailMedium: {
            type: String,
            required: true,
        },
        videoThumbnailLarge: {
            type: String,
            required: true,
        },
        // true: постер — LCP на десктопе (без lazy, fetchpriority=high)
        priority: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isShowVideo: false,
            frameWidth: 0,
            frameHeight: 0,
            viewportWidth: window.innerWidth,
            messageHandler: null,
        };
    },
    created() {
        this.messageHandler = (event) => {
            try {
                const message = JSON.parse(event.data);
                if (message.type === "player:ready") {
                    if (!this.isShowVideo) {
                        return;
                    }
                    this.onPlay();
                }
            } catch (e) {
            }
        };

        window.addEventListener("message", this.messageHandler);
    },
    mounted() {
        window.addEventListener("resize", this.onResize);
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.onResize);
        if (this.messageHandler) {
            window.removeEventListener("message", this.messageHandler);
        }
    },
    computed: {
        isSmallScreen() {
            return this.viewportWidth <= AppConstant.MOBILE_WIDTH;
        },
        // LCP на десктопе; на мобайле приоритет у hero — постер остаётся lazy
        isLcpThumbnail() {
            return this.priority && this.viewportWidth > AppConstant.DESKTOP_WIDTH;
        },
        thumbnailLoading() {
            return this.isLcpThumbnail ? 'eager' : 'lazy';
        },
        thumbnailFetchPriority() {
            return this.isLcpThumbnail ? 'high' : 'low';
        },
        thumbnailSrc() {
            if (this.viewportWidth <= AppConstant.MOBILE_WIDTH) {
                return this.videoThumbnailSmall;
            }
            if (this.viewportWidth <= AppConstant.DESKTOP_WIDTH) {
                return this.videoThumbnailMedium;
            }
            return this.videoThumbnailLarge;
        },
        iframeSrc() {
            return this.videoEmbedUrl + '?autoplay=1';
        },
    },
    methods: {
        onResize() {
            this.viewportWidth = window.innerWidth;
            if (this.isShowVideo) {
                this.recalcSize();
            }
        },
        recalcSize() {
            if (!this.$refs.container) {
                return;
            }

            const width = this.$refs.container.offsetWidth || 0;
            this.frameWidth = width;
            this.frameHeight = Math.round(AspectRationHelper.get16x9(width));
        },
        onShowVideo() {
            this.isShowVideo = true;
            nextTick(() => {
                this.recalcSize();
            });
        },
        onPlay() {
            nextTick(() => {
                if (!this.$refs.video) {
                    return;
                }
                const contentWindow = this.$refs.video.contentWindow;
                contentWindow.postMessage(JSON.stringify({
                    type: "player:play",
                    data: {},
                }), "*");
                contentWindow.postMessage(JSON.stringify({
                    type: "player:setVolume",
                    data: {
                        volume: 0.9,
                    },
                }), "*");
            });
        },
    },
    components: {
        Button,
    },
};
</script>

<style scoped>
.landing_video {
    width: 100%;
}
.landing_video__thumbnail {
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;
    cursor: pointer;
}
.landing_video__thumbnail img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
}
.landing_video__frame {
    width: 100%;
    aspect-ratio: 16 / 9;
}
.landing_video__frame iframe {
    display: block;
    width: 100%;
    height: 100%;
}
@media (max-width: 576px) {
    .landing_video__actions {
        min-height: 3rem;
    }
}
</style>
